import React from 'react';
import PropTypes from 'prop-types';

const formatValue = (val) => {
  if (typeof val === 'number') {
    return Number.parseFloat(val).toFixed(2);
  }
  return val;
};

const DataCell = (props) => {
  const {
    units, value,
  } = props;
  return (
    <div>
      {formatValue(value)}
      <sub>{units}</sub>
    </div>
  );
};

export default DataCell;

DataCell.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  units: PropTypes.string.isRequired,
};
